module.exports = __webpack_public_path__ + "img/no_address.11393b45.svg";